import React from 'react';
import TableC from '../../../basicElement/TableC';

const columns = [
    {
        title: '项目编号',
        dataIndex: 'investigationCode',
        width: 120,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        width: 200,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        width: 100,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        width: 80,
    }, {
        title: '研究产品类型',
        dataIndex: 'investigationMedicineName',
        width: 100,
    }, {
        title: '项目分期',
        dataIndex: 'investigationByStageName',
        width: 100,
    }
];

function InvestigationInfo({ data }) {
    return (
        <TableC
            columns={columns}
            data={data ? [data] : []}
            rowKey='investigationId'
            className="invTable"
        />
    );
}

export default InvestigationInfo;


// WEBPACK FOOTER //
// ./src/components/user/require/tables/InvestigationInfo.js